/**
 *
 * FlashCardDetail
 *
 */
import { mapState } from 'vuex';

import { FLASH_CARD_FAVORITE_PAGE_CHUNK_NAME } from '@/constants';

export const FlashCardExerciseTypeMixin = {
  name: 'FlashCardExerciseTypeMixin',

  computed: {
    ...mapState('FlashCard/FlashCardDetail', {
      ms_flashCardExerciseType: 'flashCardExerciseType',
    }),

    c_isCourseFavoriteFlashCardExerciseType() {
      return FLASH_CARD_FAVORITE_PAGE_CHUNK_NAME === this.$route.name;
    },

    c_flashCardExerciseType() {
      return this.c_isCourseFavoriteFlashCardExerciseType
        ? 'favorite'
        : this.ms_flashCardExerciseType;
    },

    c_isSequenceFlashCardExerciseType() {
      return 'sequence' === this.c_flashCardExerciseType;
    },

    c_isRandomFlashCardExerciseType() {
      return 'random' === this.c_flashCardExerciseType;
    },

    c_isReviseFlashCardExerciseType() {
      return 'revise' === this.c_flashCardExerciseType;
    },

    c_isFavoriteFlashCardExerciseType() {
      return 'favorite' === this.c_flashCardExerciseType;
    },

    c_isAddQuestionFlashCardExerciseType() {
      return this.c_isSequenceFlashCardExerciseType || this.c_isRandomFlashCardExerciseType;
    },
  },
};
